// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"415":"fec79335","894":"75a3b0d1"}[chunkId] + ".chunk.js";
};